module.exports = __webpack_public_path__ + "img/logo-quac2.7e5da364.svg";